import $ from 'jquery';

export default function initLazyLoadImages() {
    $(function() {
        $(window).on("scroll", function() {
            lazyLoadImages();
        });
        lazyLoadImages();
    })

    function lazyLoadImages() {
        const $window = $(window);
        const viewportTop = $window.scrollTop();
        const viewportBottom = viewportTop + $window.height();
        const $lazyLoadImages = $(".lazy-load-image");

        $lazyLoadImages.each(function(i) {
            const $img = $(this);
            const elementIsHidden = $img.is(":hidden");
            //console.log("elementIsHidden: " + elementIsHidden);
            if(elementIsHidden !== true) {
                const elementComesToViewPort = comesToViewPort(this, viewportTop, viewportBottom, 30);
                //console.log("elementComesToViewPort: " + elementComesToViewPort);
                if(elementComesToViewPort) {
                    $img.attr("src", $img.data("src"));
                    $img.removeAttr("data-src");
                    $img.removeClass("lazy-load-image");
                }
            }
        });
    }

    function comesToViewPort(element, viewportTop, viewportBottom, puffer) {
        const $element = $(element);
        var elementTop = $element.offset().top;
        var elementBottom = elementTop + $element.outerHeight();
        return elementBottom + puffer > viewportTop && elementTop - puffer < viewportBottom;
    }
};
